export default __webpack_public_path__ + "static/media/modal-bottom-sheet-mobile.ca7b9e08.png";